import { ReopenQueueRequest } from 'domain/usecases';
import { BaseHttpService } from 'main/factories/http';

export class RemoteReopenQueueRequest extends BaseHttpService<ReopenQueueRequest.Model> implements ReopenQueueRequest {
  async post(body: ReopenQueueRequest.Body): Promise<ReopenQueueRequest.Model> {
    return await this.request('post', body);
  }
}
